import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useNormalizedInput } from '../../hooks/useNormalizedInput.js';
import { clamp } from '../../utils/clamp.js';
import { style } from '../../utils/style.js';
import { toLocalNumberFormat } from '../../utils/toLocalNumberFormat.js';
import { inputValidStyle } from '../Input/inputValidStyle.js';
import { Text } from '../Text/Text.js';
import { parseDecimal } from './parseDecimal.js';
import { renderRangeWithTicks } from './renderRangeWithTicks.js';
const inputDisabledStyle = 'disabled:border-gray disabled:bg-main-divider';
const DEFAULT_MIN = 1;
const DEFAULT_MAX = 100;
export const InputRange = JSX((props) => {
    const { className, title, items = [], list = [], min = list.length ? 0 : DEFAULT_MIN, max = list.length ? list.length - 1 : DEFAULT_MAX, step = 1, value = list[0] || min, disabled = false, onChange, } = props;
    const normalizedProps = useNormalizedInput(props, {
        normalize: (_ = 0) => list.length ? closestValue(list)(_) : clamp(_, min, max),
        format: toLocalNumberFormat(),
    });
    const handleChange = useCallback((ev) => {
        onChange && onChange(parseDecimal(ev.target?.value));
    }, [onChange]);
    return (_jsxs("div", { className: className, children: [_jsxs("label", { className: "block relative", children: [title ? (_jsx(Text, { size: "text-m", font: "font-light", color: "text-primary-text", children: title })) : null, _jsx("input", { className: style('text-h3 w-full h-14', 'pl-m mt-xs box-border', 'text-primary-text', inputValidStyle, inputDisabledStyle), disabled: disabled, onChange: handleChange, ...normalizedProps }), renderRangeWithTicks({ list, min, max, step, disabled, value, onChange })] }), renderRangeCaption(items)] }));
});
const closestValue = (list) => (_) => list.reduce((prev, curr) => (Math.abs(curr - _) < Math.abs(prev - _) ? curr : prev));
const renderRangeCaption = (items) => (_jsx("div", { className: "flex justify-between my-xs", children: items.map((item, i) => (_jsx(Text, { size: "text-s", font: "font-light", color: "text-secondary-text", children: item }, String(i)))) }));
//# sourceMappingURL=InputRange.js.map